import { Box, Divider } from "@jewlr/storybook/core"
import React from "react"

import ImageBackgroundBanner from "components/landing/image-background-banner"
import StyledLink from "components/landing/link"

import { Title } from "../components"
import Features from "../features"
import TextBlock from "../text-block"
import WatchCollections from "../watch-collections"

import { banner, features, watchCollections } from "./data"

const WatchCare = () => (
  <Box mb="-48px" textAlign="center">
    <ImageBackgroundBanner element={banner()} firstElement lazyload={false} />
    <Box pt={5} px={{ _: 2, tablet: 0 }}>
      <TextBlock
        description="Keep your timepiece looking and working its best with some simple and
        easy-to-follow maintenance tips."
        descriptionStyle={{
          width: { _: "95%", desktop: "40%", tablet: "54%", widescreen: "27%" },
        }}
        title="Caring For Your Watch"
      />
      <Features data={features()} descriptionOnTop />
    </Box>
    <Box mb={5} px={{ _: 2, tablet: 0 }}>
      <Divider
        display={{ tablet: "none" }}
        height="1px"
        mb={5}
        width={{ _: "100%", tablet: "50%" }}
      />
      <Title fontSize={{ _: 22, tablet: 25 }} mb={1}>
        Questions? Check out our FAQs!
      </Title>
      <StyledLink type="underline" url="/helpdesk">
        Learn More
      </StyledLink>
    </Box>
    <WatchCollections data={watchCollections()} />
  </Box>
)

export default WatchCare
